<template>
  <div :style="{'background': user.saasApp.topMenuColor}"
       class=" top-bar color-scheme-bright">
    <div class="logo-w menu-size">
      <router-link class="logo"
                   to="/">
        <!-- <div class="logo-element" :style="{ backgroundImage: 'url(' + displayAppImage + ')' }"/> -->

        <img :src="displayAppImage" >

        <div class="logo-label">
          {{ displayAppName }}
        </div>
      </router-link>
    </div>
  

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'app-header',
	components: {
	

	},
	methods: {
		logout () {
			this.$auth.logout({
				makeRequest: true,
				redirect: '/login'
			})
		}
	},
	computed: {
		...mapGetters('User', ['user']),

		displayAppName () {
			if (this.user.saasApp) {
				return this.user.saasApp.displayCompanyName
			}
		},
		displayAppImage () {
			if (this.user.saasApp) {
				return `${this.user.saasApp.companyLogo}`
			}
		}
	}
}
</script>
<style>
.light.message-list.os-dropdown.light.message-list li > a .message-content .message-from {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/app/user/partials/header/index.vue